import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function DoubtsPage() {
  return <InstituteCrudPage config={entityConfigs['doubts']} />;
}
